import React from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import ContentList from '@/components/ContentList/ContentList';
import routePaths from '@/consts/route/routePaths';
import {twx} from '@/utils/tailwindUtils';

const AutoDeliveryBenefits = ({className, benefitsList, itemName}) => {
    const title = <AemEditableText pageName={routePaths.HOME_PAGE} itemName={itemName} render={(title) => title} />;

    return (
        <article className={twx('flex flex-col gap-4 empty:hidden', className)}>
            {title && <h3 className='text-20 leading-14'>{title}</h3>}
            <ContentList list={benefitsList} className='rounded-xl bg-primary-dark-5 p-4 md:flex-1' />
        </article>
    );
};

export default AutoDeliveryBenefits;
